import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import { modal } from '@/share/components';
import { api } from '@/server';
import URLS, { apiHost } from '@/server/urls';
import { computed, ref } from 'vue';
import { useAuthorStore } from '@/stores';
export const useUploadFile = () => {
  const {
    runAsync: uploadFile
  } = fetchApi(api.common.upload);
  const {
    runAsync: delUploadTempFile
  } = fetchApi(api.common.delUpload);
  const {
    runAsync: delUploadFile
  } = fetchApi(api.common.delFile);
  const authorStore = useAuthorStore();
  const loading = ref(false); // 上传中
  const fileList = ref([]); // 上传的文件列表
  const maxCount = ref(1); // 最大上传数量
  const filter = ref([]); // 允许上传的文件类型
  const maxSize = ref(0); // 文件大小限制，单位：字节

  const actionUrl = ref(URLS.common.upload);
  const emit = defineEmits(['update:value', 'uploadSuccess', 'uploadError', 'download', 'preview', 'remove']);
  const postData = ref({});
  const postHeaders = computed(() => {
    return {
      'x-access-token': authorStore.token
    };
  });
  const canUpload = computed(() => {
    return fileList.value.length < maxCount.value;
  });
  const handleDownload = file => {
    const {
      url
    } = file || {};
    if (!url) return;
    emit('download', file);
    try {
      let targetUrl;
      if (url.indexOf('?') === -1) {
        targetUrl = `${url}?action=download`;
      } else {
        targetUrl = `${url}&action=download`;
      }
      window.open(targetUrl, '_blank');
    } catch (e) {}
  };
  const handlePreview = file => {
    const {
      url
    } = file || {};
    if (!url) return;
    emit('preview', file);
    try {
      window.open(url, '_blank');
    } catch (e) {}
  };
  const handleRemove = async file => {
    const {
      status,
      action,
      fileId
    } = file || {};
    if (status === 'done' && action === 'upload') {
      // 删除上传的临时文件
      const {
        error
      } = await delUploadTempFile({
        filename: file.name,
        extra: file.uid
      });
      if (error) {
        modal.message.error(error);
        return false;
      }
    } else if (fileId) {
      const confirm = await modal.confirm('删除确认', `确认要删除文件[${file.name}]吗?删除后不可恢复`);
      if (!confirm) return false;
      // 删除服务端文件
      const {
        error
      } = await delUploadFile({
        fileId
      });
      if (error) {
        modal.notification.error(error, '删除文件').catch();
        return false;
      }
      modal.notification.success(`删除文件[${file.name}]成功`, '删除文件').catch();
      emit('remove', file);
    }
    // 其他情况，直接删除
    return true; // 返回false表示不删除文件
  };
  const handleChange = info => {
    const {
      file
    } = info || {};
    if (!file) return;
    const {
      status,
      error,
      response
    } = file; // status: uploading done error removed
    if (status === 'uploading') {
      loading.value = true;
      return;
    }
    if (status === 'done') {
      // 上传完成
      loading.value = false;
      const idx = fileList.value.slice().findIndex(item => item.uid === file.uid);
      if (idx === -1) return;
      const rows = fileList.value.slice();
      const resFile = {
        ...response,
        uid: file.uid,
        action: 'upload',
        status: 'done'
      };
      rows[idx] = resFile;
      fileList.value = rows;
      const uploadFiles = rows.map(t => {
        const {
          status,
          action,
          ...info
        } = t;
        if (status === 'done' && action === 'upload') {
          return {
            ...info
          };
        }
        return null;
      }).filter(t => !!t);
      emit('uploadSuccess', resFile, uploadFiles);
      emit('update:value', fileList.value);
      return;
    }
    if (status === 'removed') {
      const rows = fileList.value.slice().filter(v => v.status !== 'removed');
      fileList.value = rows;
      emit('update:value', rows);
    }
    if (status === 'error') {
      loading.value = false;
      emit('uploadError', file, error);
      modal.message.error(error);
    }
  };

  // 上传文件验证
  const beforeUpload = file => {
    const {
      name,
      size
    } = file || {};
    if (!name) return false;
    const ext = name.substr(name.lastIndexOf('.')); // 获取文件后缀
    const allowExtensions = filter.value || [];
    if (allowExtensions.length > 0 && allowExtensions.findIndex(t => t === ext) === -1) {
      file.status = 'error';
      file.error = `不支持上传${ext}格式的文件`;
      return false;
    }
    // 文件大小限制
    if (maxSize.value > 0 && size > maxSize.value) {
      file.status = 'error';
      file.error = `文件大小不能超过${maxSize.value / 1024 / 1024}M`;
      return false;
    }
    return true;
  };

  // 自定义上传方法
  const customRequest = options => {
    const {
      data,
      headers,
      filename
    } = options || {};
    if (!options.file) return;
    uploadFile({
      data,
      files: [{
        key: filename,
        file: options.file,
        name: options.file.name
      }],
      headers
    }).then(res => {
      const {
        error,
        url,
        ...data
      } = res || {};
      if (error) {
        options.onError(error);
        return;
      }
      options.onSuccess({
        ...data,
        url: `${url ? apiHost + url : ''}`,
        status: 'success'
      });
    }).catch(err => {
      options.onError(err);
    });
  };
  return {
    actionUrl,
    filter,
    maxSize,
    loading,
    canUpload,
    postData,
    postHeaders,
    handleChange,
    handleRemove,
    handlePreview,
    handleDownload,
    maxCount,
    fileList,
    beforeUpload,
    customRequest
  };
};